import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';
import { Grid3X3, ArrowUpRight } from 'lucide-react';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl bg-brand-50 flex items-center justify-center">
            <Grid3X3 className="w-5 h-5 text-brand-600" />
          </div>
          <div>
            <h2 className="font-display text-xl md:text-2xl font-bold text-warm-900">{t('popularCategories')}</h2>
            <p className="text-sm text-warm-500 mt-0.5">{t('selectCategory')}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col rounded-xl overflow-hidden border border-warm-200 hover:border-brand-300 bg-white transition-all duration-200"
            >
              <div className="relative aspect-square overflow-hidden bg-warm-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  title={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex items-center justify-between gap-1 px-3 py-2.5 bg-white border-t border-warm-100">
                <span className="text-xs font-medium text-warm-800 group-hover:text-brand-700 text-left leading-tight line-clamp-2">{cat.name}</span>
                <ArrowUpRight className="w-3.5 h-3.5 text-warm-400 group-hover:text-brand-500 flex-shrink-0" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}